import React from 'react';
import { tr } from '../../i18n';
import { SystemStateAction } from './EmptyState';
import './system-states.css';

type ForbiddenStateProps = {
  title?: string;
  description?: string;
  actions?: SystemStateAction[];
};

const ForbiddenState: React.FC<ForbiddenStateProps> = ({
  title = tr.shell.systemStates.forbiddenTitle,
  description = tr.shell.systemStates.forbiddenDescription,
  actions
}) => (
  <div className="sys-state">
    <div className="sys-state-icon-wrap sys-state-icon-wrap--warning">🔒</div>
    <h3 className="sys-state-title">{title}</h3>
    {description && <p className="sys-state-desc">{description}</p>}
    {actions && actions.length > 0 && (
      <div className="sys-state-actions">
        {actions.map((a, i) => {
          const cls = `sys-state-btn sys-state-btn--${a.variant ?? 'outline'}`;
          return a.href
            ? <a key={i} href={a.href} className={cls}>{a.label}</a>
            : <button key={i} type="button" className={cls} onClick={a.onClick}>{a.label}</button>;
        })}
      </div>
    )}
  </div>
);

export default ForbiddenState;
